import { IGetDeltaHedgeOrderDTO } from "src/Tables/OptionDomain/PairPoisition/Additional/DeltahedgeOrder";
import { Packet } from "../Interfaces/commonDtos";
import {
  IBulkOrderRow,
  IDeleteOMSOrder,
  IDeltaHedgeOrderbookParams,
  IDeltaHedgeOrderbookResp,
  IDeltaHedgeOrderEditValues,
  IDeltaHedgeOrderFormValues,
  IDeltaHedgeOrderTableReport,
  IDeltaHedgeOrderTablesSearchParam,
  IUpdateDeltaHedgeTargetDto,
} from "../Interfaces/deltaHedgeOrder";
import { Graph_Dto } from "../Interfaces/orderbookGraphInterfaces";
import { ErrorTableReport } from "../Interfaces/orderInterfaces";
import { Report } from "../Interfaces/TableInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { AxiosRequestConfig } from "axios";
import { IShekarOrderMetricEventsResponse } from "src/Interfaces/shekarMetricEvents";

export const getDeltaHedgeOrderTable = (
  searchParam: IDeltaHedgeOrderTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IDeltaHedgeOrderTableReport>> =>
  getTable<IDeltaHedgeOrderTablesSearchParam, IDeltaHedgeOrderTableReport>(
    `/v1/deltaHedgeOrder/orderTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getDeltaHedgeAggregatorTable = (
  searchParam: IDeltaHedgeOrderTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IDeltaHedgeOrderTableReport>> =>
  getTable<IDeltaHedgeOrderTablesSearchParam, IDeltaHedgeOrderTableReport>(
    `/v1/DeltaHedgeOrder/AggregatorOrderTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getDeltaHedgeOrderTradeTable = (
  searchParam: IDeltaHedgeOrderTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IDeltaHedgeOrderTableReport>> =>
  getTable<IDeltaHedgeOrderTablesSearchParam, IDeltaHedgeOrderTableReport>(
    `/v1/deltaHedgeOrder/tradeTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );
export const getDeltaHedgeOrderErrorTable = (
  searchParam: IDeltaHedgeOrderTablesSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable<IDeltaHedgeOrderTablesSearchParam, any>(
    `/v1/deltaHedgeOrder/errorTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getDeltaHedgeOrderChancesTable = (
  searchParam: {
    id?: number;
    conditionId?: number;
  },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/orderChancesTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
export const getDeltaHedgeOrderTradeChancesTable = (
  searchParam: {
    id: number;
  },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/tradeChancesTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getDeltaHedgeOrderBrokerOrderTable = (
  searchParam: {
    id?: number;
    conditionId?: number;
  },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/BrokerOrderTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getDeltaHedgeOrderDetailsOrderTable = (
  searchParam: {
    id?: number;
    conditionId?: number;
  },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/OrderTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getDeltaHedgeOrderBrokerTradeTable = (
  searchParam: {
    id: number;
  },
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/BrokerTradeTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const deltaHedgeOrderTablePause = (
  ids: number[],
  IsConditionId: boolean = false,
): Promise<Packet<boolean>> =>
  putRequest("/v1/deltaHedgeOrder/orderTablePause", { ids, IsConditionId });

export const deltaHedgeOrderTablePlay = (
  ids: number[],
  IsConditionId: boolean = false,
): Promise<Packet<boolean>> =>
  putRequest("/v1/deltaHedgeOrder/orderTablePlay", { ids, IsConditionId });

export const deleteDeltaHedgeOrders = (
  ids: number[],
  IsConditionId: boolean = false,
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/deltaHedgeOrder/deleteOrders`, { ids, IsConditionId });

export const deleteDeltaHedgeOpenOrders = (
  ids: number[],
  IsConditionId: boolean = false,
): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/deltaHedgeOrder/deleteOpenOrder`, { ids, IsConditionId });

export const getDeltaHedgeOrderChart = (id: number): Promise<Graph_Dto[]> =>
  getRequest(`/v1/deltaHedgeOrder/orderChart?id=${id}`);

export const getDeltaHedgeOrderEvents = (
  algorithmOrderId: number,
  conditionId: number,
  windowLen: number = 5,
  axiosOptions?: AxiosRequestConfig,
): Promise<IShekarOrderMetricEventsResponse> =>
  getRequest(
    `/v1/deltaHedgeOrder/Events?algorithm_order_id=${algorithmOrderId}&condition_id=${conditionId}&windowLen=${windowLen}`,
    axiosOptions,
  );

export const getDeltaHedgeAggregationChart = (
  conditionId: number,
): Promise<Graph_Dto[]> =>
  getRequest(`/v1/deltaHedgeOrder/orderChart?conditionId=${conditionId}`);

export const getDeltaHedgeOrderTradeChart = (
  id: number,
): Promise<Graph_Dto[]> =>
  getRequest(`/v1/deltaHedgeOrder/tradeChart?id=${id}`);

export const addDeltaHedgeOrder = (
  dto: IDeltaHedgeOrderFormValues,
): Promise<Packet<boolean>> => postRequest(`/v1/deltaHedgeOrder/add`, dto);

export const editDeltaHedgeOrder = (
  dto: IDeltaHedgeOrderEditValues,
): Promise<Packet<boolean>> => putRequest(`/v1/deltaHedgeOrder/edit`, dto);

export const addDeltaHedgeOrderBulkOrder = (
  orderRows: Array<IBulkOrderRow> | null,
): Promise<Report<ErrorTableReport>> =>
  postRequest("/v1/deltaHedgeOrder/addBulkOrder", orderRows);

export const getDeltaHedgeOrders = (
  dto: IGetDeltaHedgeOrderDTO,
): Promise<IDeltaHedgeOrderFormValues[]> =>
  postRequest(`/v1/deltaHedgeOrder/getOrder`, dto);

export const uploadDeltaOrderFile = (
  searchParam: FormData | null,
): Promise<Report<any>> =>
  getTable<FormData | null, any>(
    "/v1/deltaHedgeOrder/uploadOrderFile",
    searchParam,
    null,
    null,
    undefined,
  );

export const getDeltaHedgeOrderBook = (
  body: IDeltaHedgeOrderbookParams,
): Promise<IDeltaHedgeOrderbookResp> =>
  postRequest("/v1/DeltaHedgeOrder/GetOrderBook", body);

export const getDeltaHedgeOrderDeletedOMSOrders = (
  searchParam: {},
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<any>> =>
  getTable(
    `/v1/deltaHedgeOrder/DeletedOMSOrdersTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const deleteOMSOrders = (
  formValues: IDeleteOMSOrder,
): Promise<Packet<boolean>> =>
  deleteRequest("/v1/deltaHedgeOrder/DeleteOMSOrders", formValues);

export const updateTarget = (
  formValues: IUpdateDeltaHedgeTargetDto,
): Promise<Packet<boolean>> =>
  putRequest(`/v1/DeltaHedgeOrder/UpdateTarget`, formValues);
